import * as timeGadgets from "./timeGadgets";

export default {
  datetimeFormatter (date) {
    return timeGadgets.datetimeFormatter(date);
  },
  dateFormatter (date) {
    return timeGadgets.dateFormatter(date);
  },
  objEmptyFilter (obj) {
    let o = {};
    for (let i in obj) {
      if (typeof obj[i] !== "undefined" && obj[i] !== null && obj[i] !== "") {
        o[i] = obj[i];
      }
    }
    return o;
  },
  toYuan (source, noSign = false) {
    return typeof source === "number"
      ? `${noSign ? "" : "￥ "}${parseFloat(source / 100).toFixed(2)}`
      : "-";
  },
  image (source) {
    return source
      ? source.includes("data:image")
        ? source
        : `/mch_web/v1/browse_picture?url=${encodeURIComponent(source)}`
      : "";
  },

  acccountStatus (source) {
    switch (source) {
      case 1:
        return "启用";
      case 2:
        return "禁用";
      default:
        return source;
    }
  },
  acccountBindStatus (source) {
    switch (source) {
      case 1:
        return "未绑定";
      case 2:
        return "已绑定";
      default:
        return source;
    }
  },

  proxyChannel (source) {
    if (!source && source !== 0) {
      return "-";
    }
    switch (source) {
      case "AliPay":
        return "支付宝";
      case "WeiXin":
        return "微信";
      case "SwiftPass":
        return "浦发威富通";
      case "HuiePay":
        return "汇宜";
      default:
        return source;
    }
  },

  outlay_act_type (source) {
    switch (source) {
      case 1:
        return "额度充值";
      case 2:
        return "额度提现";
      case 3:
        return "额度转积分";
      case 4:
        return "积分转额度";
      case 5:
        return "额度转现金券";
      case 6:
        return "现金券转额度";
      default:
        return source;
    }
  },
  outlay_act_status (source) {
    switch (source) {
      case 1:
        return "待审核";
      case 2:
        return "成功";
      case 3:
        return "失败";
      default:
        return source;
    }
  },
  billType (source) {
    if (!source && source !== 0) {
      return "-";
    }
    switch (parseInt(source)) {
      case 1:
        return "支付";
      case 2:
        return "退款";
      case 3:
        return "拆出";
      case 4:
        return "拆入";
      default:
        return source;
    }
  },
  payStatus (source) {
    if (!source && source !== 0) {
      return "-";
    }
    switch (parseInt(source)) {
      case 1:
        return "待支付";
      case 2:
        return "支付成功";
      case 3:
        return "交易关闭";
      case 4:
        return "交易结束";
      case 5:
        return "交易失败";
      case 6:
        return "业务关单时查询已经交易成功，需要人工退款";
      default:
        return source;
    }
  },
  settle_type_short (source) {
    switch (source) {
      case 1:
        return "银行卡";
      case 2:
        return "微众钱包";
      case 3:
        return "富力钱包";
      default:
        return source;
    }
  },
  settle_type_long (source) {
    switch (source) {
      case 1:
        return "银行卡结算";
      case 2:
        return "微众钱包结算";
      case 3:
        return "富力钱包结算";
      default:
        return source;
    }
  },
  // 结算方式
  settle_type_list (source) {
    switch (source) {
      case 1:
        return "银行卡";
      case 2:
        return "微众钱包";
      case 3:
        return "富力钱包";
      default:
        return source;
    }
  },
  pay_type (source, id) {
    switch (source.type) {
      case 1:
        return "财务结算";
        break;
      case 2:
        return "充值";
        break;
      case 3:
        return "提现";
        break;
      case 4:
        return "支付";
        break;
      case 5:
        return "收入";
        break;
      case 6:
        return "退款";
        break;
      case 7:
        return "支付";
        break;
      case 8:
        if (source.wallet_id != id) {
          return "收入";
        }
        return "扣款";
        break;
      default:
        return source;
        break;
    }
  },
  pay_type_select (source) {
    switch (source) {
      case 1:
        return "财务结算";
        break;
      case 2:
        return "充值";
        break;
      case 3:
        return "提现";
        break;
      case 4:
        return "支付";
        break;
      case 5:
        return "收入";
        break;
      case 6:
        return "退款";
        break;
      case 8:
        return "扣款";
        break;
      default:
        return source;
        break;
    }
  },
  detail_status (source) {
    switch (source) {
      case 2:
        return "进行中";
        break;
      case 3:
        return "交易成功";
        break;
      case 4:
        return "交易失败";
        break;
      case 5:
        return "交易关闭";
        break;
      default:
        return source;
        break;
    }
  },
  // 截取后4位
  substringForLast4 (source) {
    return source ? source.substring(source.length - 4) : "";
  },
  symbol (source, id) {
    switch (source.type) {
      case 1:
        return "+";
        break;
      case 2:
        return "+";
        break;
      case 3:
        return "-";
        break;
      case 4:
        return "-";
        break;
      case 5:
        return "+";
        break;
      case 6:
        return "+";
        break;
      case 7:
        return "-";
        break;
      case 8:
        if (source.wallet_id != id) {
          return "+";
        }
        return "-";
        break;
      default:
        return source;
        break;
    }
  },
  // 前端脱敏
  desensitization (source, beginStr = 3, endStr = 7, length = 11) {
    if (!source) {
      return "";
    }
    source = source + "";
    // if (source.length === length) {
    let len = source.length;
    let leftStr = source.substring(0, beginStr);
    let rightStr = source.substring(len - 4, len);
    let str = "";
    let i = 0;
    try {
      for (i = 0; i < endStr - beginStr; i++) {
        str = str + "*";
      }
    } catch (error) { }
    str = leftStr + str + rightStr;
    return str;
    // }
    // return source
  },
  // 钱包变更状态
  wallet_audit_status (source) {
    switch (source) {
      case 1:
        return "待审核";
      case 2:
        return "审核成功";
      case 3:
        return "审核失败";
      default:
        return source;
    }
  },
  // 商户新状态
  merchants_audit_status (source) {
    switch (source) {
      case 0:
        return "审核中";
      case 1:
        return "变更中";
      case 2:
        return "变更成功";
      case 3:
        return "变更失败";
      default:
        return source;
    }
  },
};
